import * as Utils from "../utils/Config";
import { AuthContextModel } from "../App";
import { ApiClient, IPaginatedResponse } from "./ApiClient";
import { ICareProvider } from "../models/ICareProvider";
import { objectToQueryString } from "../helpers/ApiHelper";
import { IRiskPotReportPreAssessment, IRiskPotReportPreAssessmentSearchParams, IRiskPotReportPreAssessmentStatus } from "../models/IRiskPotReport";

export class RiskPotReportPreAssessmentSearchApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    searchPreAssessments(searchParams: IRiskPotReportPreAssessmentSearchParams, success: (riskPotReports: IPaginatedResponse<IRiskPotReportPreAssessment[]>) => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getPaginated(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessmentSearch?${queryString}`, success, error, final);
    }

    searchPreAssessmentsAsExcel(searchParams: IRiskPotReportPreAssessmentSearchParams, fileName: string, success?: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString(searchParams);
        this.getFile(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessmentSearch?${queryString}&exportExcel=true`, fileName, success, error, final);
    }

    getCareProviders(success: (riskPotReports: ICareProvider[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessmentSearch/careProviders`, success, error, final);
    }

    getRiskPotPreAssessmentStatuses(success: (statuses: IRiskPotReportPreAssessmentStatus[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportPreAssessmentSearch/riskPotPreAssessmentStatuses`, success, error, final);
    }
}